module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I wish to acknowledge and thank the Trustees of the Liddell Hart Centre for Military Archives for permission to use quotations form their archives.")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59713784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Acknowledgements.vue
// module id = 69
// module chunks = 0